export enum LeaveEntitlementOverbalanceHandling {
NotAllowed,
Warning,
}
